<template>
  <naj-dynamic-form
    v-if="dynamicForm"
    :form-model="formModel"
    :root-form-model="rootFormModel"
    :form-fields="dynamicForm.fields"
    :custom-component-name="dynamicForm.customComponentName"
    :required-data="requiredData"
    :view-mode="viewMode"
    @change="$emit('formChanged')"
  ></naj-dynamic-form>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('GlobalModule');

export default {
  inject: ['$validator'],
  props: ['formId', 'formModel', 'rootFormModel', 'requiredData', 'viewMode'],
  data() {
    return { dynamicForm: null };
  },
  watch: {
    formId() {
      if (this.formId) this.getForm();
    },
  },
  created() {
    if (this.formId) this.getForm();
  },
  methods: {
    ...mapActions(['getDynamicForm']),
    getForm() {
      this.getDynamicForm({
        formId: this.formId,
        withoutParse: true,
      })
        .then(
          form => (this.dynamicForm = form)
        );
    },
  },
};
</script>
